export default __webpack_public_path__ + "static/media/Mark-Light.v1.56ce8229.woff";